const Save = ( { attributes } ) => (
	<div className={ attributes.container }></div>
);

export default Save;
